<template>
	<div class="basic_wrap" style="overflow: hidden;">
		<div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('user.downapp')}}</div>
        </div>
		<div class="wrap_box">
			<div class="down_logo">
				<div class="logo_ball">
					<img src="../images/home/logo2.png"  />
				</div>
			</div>
			<div  class="app_but">
				<div  class="appBut">
					<img src="../images/home/android.png"  />
					<p >Andirid</p></div>
				<div  class="appBut buts">
					<img src="../images/home/apple.png"  />
					<p >IOS</p></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "login",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				
			}
		}
	};
</script>

<style lang="less" scoped>
    .red_top_bg{
        border-radius:0px;
    }
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: transparent;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ececec;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}
	.down_logo{
	    width: 100%;
	    height: 40vh;
	    background: url(../images/home/Frame384.png) no-repeat;
	    background-size: 100% 100%;
	    position: relative;
		.logo_ball{
		    width: 156px;
		    height: 156px;
		    border-radius: 50%;
		    position: absolute;
		    bottom: 5px;
		    left: 30%;
		    background-color: #fff;
		    display: flex;
		    align-items: center;
		    justify-content: center;
			img {
			    width: 320px;
			    height: 240px;
			    display: inline-block;
			    overflow: hidden;
			    position: relative;
				-webkit-animation: once-show 1s;
				animation: once-show 1s;
			}
		}
	}
	.app_but{
	    width: 100%;
	    height: 145px;
	    display: flex;
	    flex-direction: column;
	    justify-content: space-around;
	    align-items: center;
	    margin: 10% 0;
		.buts{
		    background-color: #fc494d;
		    color: #232f3e;
		}
	}
	.appBut{
		width: 80%;
		height: 40%;
		background-color: #232f3e;
		box-shadow: rgba(0,0,0,.05),0 0 4px;
		color: #fc494d;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		font-size: 1.3em;
		font-weight: bold;
		img{
		    width: 26px;
		    height: 26px;
		    margin: 0 2%;
		}
		.buts{
		    background-color: #fc494d;
		    color: #232f3e;
		}
	}
	@-webkit-keyframes once-show {
	    0% {
	        top: 0
	    }
	}
	
	@keyframes once-show {
	    0% {
	        top: 0
	    }
	}
</style>
